import type { RouteObject } from 'react-router';

import { DefaultErrorElement } from 'src/app/DefaultErrorElement';
import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const reportsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./ReportsOverviewRoute/ReportsOverviewRoute').then((m) => ({
        Component: m.ReportsOverviewRoute,
      })),
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'drivers',
    lazy: () =>
      import('./DriverReportsRoute/DriverReportsRoute').then((m) => ({
        Component: m.DriverReportsRoute,
      })),
  },
  {
    path: 'payers',
    lazy: () =>
      import('./PayerReportsRoute/PayerReportsRoute').then((m) => ({
        Component: m.PayerReportsRoute,
      })),
  },
  {
    path: 'custom',
    lazy: () =>
      import('./CustomReportsRoute/CustomReportsRoute').then((m) => ({
        Component: m.CustomReportsRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/reports" linkText="Go back to reports" />
    ),
  },
];
